import React from 'react';
import Popover from 'react-bootstrap/lib/Popover';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import util from '../../../lib/util';
import AddressToString from '../AddressToString';
import ServiceOrderInfo from './ServiceOrderInfo';
class ProjectInfo extends React.Component {

    getCostTitle(p) {
        return p && p.status == 'Completed' && p.cost > 0 ? 'Cost' : 'Estimated cost';
    }

    getDateTitle(p) {
        return (p && p.status == 'Submitted' ? 'Submission' : (p && p.status == 'Completed' ? 'Completion' : 'Cancellation')) + ' date';
    }
    render() {
        const p = this.props.project;
        const lookup = window.osa && window.osa.lookup;
        const st = lookup && lookup.status;
        const tip = st[p && p.status] && st[p && p.status].tip;
        return (
            <div>
                <div className="row">
                    <div className="col-sm-3" />
                    <div className="col-sm-5" style={{ marginBottom: "0px" }}  />
                </div>
                <div className="row" style={{ backgroundColor: "#B0C4DE" }} >
                    <div className="col-sm-12" style={{ backgroundColor: "#B0C4DE" }} >
                        <h4>Your project <i className="fa fa-angle-right" style={{ color: "#000000" }}  /></h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <h4 style={{ color: "#f4ae11" }} >Project number: {p.projectNo}</h4>
                    </div>
                </div>
                <div className="row" style={{ backgroundColor: "#B0C4DE" }}>
                    <div className="col-sm-12" style={{ backgroundColor: "#B0C4DE" }}>
                        <h4>Project details</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-4">
                                <h5 style={{ fontWeight: "bold" }} >Project number:</h5>
                                {p.projectNo}
                            </div>
                            <div className="col-sm-4">

                                <h5 style={{ fontWeight: "bold" }} >
                                    {this.getDateTitle(p)}
                                </h5>
                                {util.toFullDateString(util.dateFromString(p.statusDate))}
                            </div>
                            <div className="col-sm-4">
                                <h5 style={{ fontWeight: "bold" }}>Service product:</h5>
                                {lookup && lookup.serviceType[p.applicationType]}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <h5><b>Status:</b></h5>  {util.toProjectStatus(p.status)}&nbsp;
                           <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={(<Popover id={`tt-${p.projectNo}`}>{tip}</Popover>)}>
                                    <i className="fa fa-info-circle info-icon" />
                                </OverlayTrigger>
                            </div>
                            <div className="col-sm-4" />
                            <div className="col-sm-4" >
                                {p.status != 'Cancelled' && p.cost > 0 ?
                                    <div>
                                        <h5>
                                            <b> {this.getCostTitle(p)}:</b>
                                        </h5>
                                        ${p.cost}
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>
                        <div className="row" style={{ backgroundColor: "#B0C4DE" }}>
                            <div className="col-sm-12" style={{ backgroundColor: "#B0C4DE" }}>
                                <h4>Site details</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <h5 style={{ fontWeight: "bold" }}>Site address:</h5>
                                        <AddressToString {...p.siteAddress} />
                                    </div>
                                    <div className="col-sm-4">
                                        <h5 style={{ fontWeight: "bold" }}>Work site contact:</h5>
                                        {
                                            p.primarySiteContact ?
                                                <div>
                                                    {p.primarySiteContact.companyName || ''}
                                                    {p.primarySiteContact.name} <br />
                                                    Primary phone: {util.formatPhoneNumber(p.primarySiteContact.workPhone)} <br />
                                                    Mobile phone: {util.formatPhoneNumber(p.primarySiteContact.cellPhone)}
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                    <div className="col-sm-4">
                                        <h5 />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ backgroundColor: "#B0C4DE" }}>
                            <div className="col-sm-12" style={{ backgroundColor: "#B0C4DE" }}>
                                <h4>Service orders</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="row" style={{ borderBottom: "2px solid #dddddd", paddingBottom: "0px" }} >
                                    <div className="col-sm-3"><h5 style={{ fontWeight: "bold", marginTop: "25px", marginBottom: "0px" }}>Service product</h5></div>
                                    <div className="col-sm-2">
                                        <h5 style={{ marginTop: "25px", marginBottom: "0px" }}>
                                            <b>Status</b>
                                        </h5>
                                    </div>
                                    <div className="col-sm-3"><h5 style={{ fontWeight: "bold", marginTop: "25px", marginBottom: "0px" }}>Schedule date</h5></div>
                                    <div className="col-sm-4"><h5 style={{ fontWeight: "bold", marginTop: "25px", marginBottom: "0px" }}>Premise address</h5></div>
                                </div>
                                {
                                    p.serviceOrders ?
                                        <div>
                                            {p.serviceOrders.map((x, key) => <ServiceOrderInfo serviceOrder={x} key={key} />)}
                                        </div>
                                        : null
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectInfo;


